module.exports = __webpack_public_path__ + "img/line0.89bd6a20.svg";